import { ToggleOptions } from 'settings/components/ToggleOptions';

export function RewardsStarCount({ value, onChange }: RewardsStarCountProps) {
  const starCountOptions = [
    { id: '4-star', text: '4 stars', value: false },
    { id: '5-star', text: '5 stars', value: true },
  ];

  return (
    <ToggleOptions
      title="Star Count"
      value={value}
      options={starCountOptions}
      onChange={newValue => onChange(newValue)}
      description="Specify the many stars your team needs to be eligible for a reward."
    />
  );
}

interface RewardsStarCountProps {
  value: boolean;
  onChange: (newValue: boolean) => void;
}
